import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const get = axios.get
const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const ListSection = createAsyncThunk('sections', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/section/list`, params), thunkAPI)
)

export const createSection = createAsyncThunk('add-section', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/section/store`, data), thunkAPI)
)

export const editSection = createAsyncThunk('section-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/section/edit/${id}`), thunkAPI)
)

export const deleteSection = createAsyncThunk('section-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/section/destroy/${id}`), thunkAPI)
)

export const ListClass = createAsyncThunk('classes', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/class/list`, params), thunkAPI)
)

export const createClass = createAsyncThunk('add-class', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/class/store`, data), thunkAPI)
)

export const editClass = createAsyncThunk('class-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/class/edit/${id}`), thunkAPI)
)

export const deleteClass = createAsyncThunk('class-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/class/destroy/${id}`), thunkAPI)
)

export const ListExamClass = createAsyncThunk('ex-classes', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/exam-class/list`, params), thunkAPI)
)

export const createExamClass = createAsyncThunk('add-ex-class', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/exam-class/store`, data), thunkAPI)
)

export const editExamClass = createAsyncThunk('ex-class-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/exam-class/edit/${id}`), thunkAPI)
)

export const deleteExamClass = createAsyncThunk('ex-class-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/exam-class/destroy/${id}`), thunkAPI)
)

export const ListAcademicYear = createAsyncThunk('ayes', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/academic-year/list`, params), thunkAPI)
)

export const createAcademicYear = createAsyncThunk('add-ay', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/academic-year/store`, data), thunkAPI)
)

export const editAcademicYear = createAsyncThunk('ay-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/academic-year/edit/${id}`), thunkAPI)
)

export const deleteAcademicYear = createAsyncThunk('ay-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/academic-year/destroy/${id}`), thunkAPI)
)

export const ToggleAcademicYear = createAsyncThunk('toggle-status', (id: string, thunkAPI) =>
  handleRequest(get(`/api/academic-year/toggle-status/${id}`), thunkAPI)
)

export const ListProgramYear = createAsyncThunk('pr-years', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/program-year/list`, params), thunkAPI)
)

export const createProgramYear = createAsyncThunk('add-pr-year', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/program-year/store`, data), thunkAPI)
)

export const editProgramYear = createAsyncThunk('pr-year-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/program-year/edit/${id}`), thunkAPI)
)

export const deleteProgramYear = createAsyncThunk('pr-year-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/program-year/destroy/${id}`), thunkAPI)
)

export const ListProgramLevel = createAsyncThunk('pr-levels', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/program-level/list`, params), thunkAPI)
)

export const createProgramLevel = createAsyncThunk('add-pr-level', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/program-level/store`, data), thunkAPI)
)

export const editProgramLevel = createAsyncThunk('pr-level-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/program-level/edit/${id}`), thunkAPI)
)

export const deleteProgramLevel = createAsyncThunk('pr-level-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/program-level/destroy/${id}`), thunkAPI)
)

export const ListSemester = createAsyncThunk('semesters', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/semester/list`, params), thunkAPI)
)

export const createSemester = createAsyncThunk('add-semester', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/semester/store`, data), thunkAPI)
)

export const editSemester = createAsyncThunk('semester-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/semester/edit/${id}`), thunkAPI)
)

export const deleteSemester = createAsyncThunk('semester-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/semester/destroy/${id}`), thunkAPI)
)

export const ListCountry = createAsyncThunk('countries', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/country/list`, params), thunkAPI)
)

export const createCountry = createAsyncThunk('add-country', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/country/store`, data), thunkAPI)
)

export const editCountry = createAsyncThunk('country-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/country/edit/${id}`), thunkAPI)
)

export const deleteCountry = createAsyncThunk('country-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/country/destroy/${id}`), thunkAPI)
)

export const ListVideoCategory = createAsyncThunk('vid-cats', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/video-category/list`, params), thunkAPI)
)

export const createVideoCategory = createAsyncThunk('add-vid-cat', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/video-category/store`, data), thunkAPI)
)

export const editVideoCategory = createAsyncThunk('vid-cat-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/video-category/edit/${id}`), thunkAPI)
)

export const deleteVideoCategory = createAsyncThunk('vid-cat-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/video-category/destroy/${id}`), thunkAPI)
)

export const ListProgram = createAsyncThunk('programs', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/program/list`, params), thunkAPI)
)

export const createProgram = createAsyncThunk('add-program', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/program/store`, data), thunkAPI)
)

export const editProgram = createAsyncThunk('program-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/program/edit/${id}`), thunkAPI)
)

export const deleteProgram = createAsyncThunk('program-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/program/destroy/${id}`), thunkAPI)
)

export const toggleProgram = createAsyncThunk('program-toggle', (id: string, thunkAPI) =>
  handleRequest(get(`/api/program/toggle-status/${id}`), thunkAPI)
)

export const ListTimeSlot = createAsyncThunk('time-slots', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/slot/list`, params), thunkAPI)
)

export const createTimeSlot = createAsyncThunk('add-ts', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/slot/store`, data), thunkAPI)
)

export const editTimeSlot = createAsyncThunk('ts-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/slot/edit/${id}`), thunkAPI)
)

export const deleteTimeSlot = createAsyncThunk('ts-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/slot/destroy/${id}`), thunkAPI)
)

export const QuestionsCats = createAsyncThunk('ques-cats', (params: {}, thunkAPI) =>
  handleRequest(get(`/api/q-cat/list`, params), thunkAPI)
)

export const createQuesCat = createAsyncThunk('add-ques-cat', (data: {}, thunkAPI) =>
  handleRequest(post(`/api/q-cat/store`, data), thunkAPI)
)

export const editQuesCat = createAsyncThunk('ques-cat-edit', (id: string, thunkAPI) =>
  handleRequest(get(`/api/q-cat/edit/${id}`), thunkAPI)
)

export const deleteQuesCat = createAsyncThunk('ques-cat-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`/api/q-cat/destroy/${id}`), thunkAPI)
)

type ToolState = {
  record: any
  records: any
  errors: any
}

const initialState: ToolState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const toolSlice = createSlice({
  name: 'tools',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListSection.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createSection.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListAcademicYear.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createAcademicYear.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListProgramYear.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createProgramYear.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListProgramLevel.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createProgramLevel.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListSemester.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createSemester.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListCountry.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCountry.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListVideoCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createVideoCategory.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListProgram.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createProgram.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = toolSlice.actions
export default toolSlice.reducer
